export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
  gameCount: number;
}

export const categories: Category[] = [
  {
    slug: 'role-playing',
    name: '角色扮演',
    description: '沉浸式剧情体验，扮演你喜欢的角色，在奇幻世界中展开冒险。',
    icon: 'ri-user-star-line',
    gameCount: 45,
  },
  {
    slug: 'action',
    name: '动作格斗',
    description: '紧张刺激的战斗体验，考验你的反应速度与操作技巧。',
    icon: 'ri-sword-line',
    gameCount: 38,
  },
  {
    slug: 'strategy',
    name: '策略战争',
    description: '运筹帷幄，排兵布阵，用智慧征服每一场战役。',
    icon: 'ri-mental-health-line',
    gameCount: 32,
  },
  {
    slug: 'simulation',
    name: '模拟经营',
    description: '打造你的理想世界，经营城市、乐园、餐厅，享受创造的乐趣。',
    icon: 'ri-building-2-line',
    gameCount: 28,
  },
  {
    slug: 'sports',
    name: '体育竞速',
    description: '感受速度与激情，在赛场上挥洒汗水，挑战极限。',
    icon: 'ri-speed-up-line',
    gameCount: 20,
  },
  {
    slug: 'adventure',
    name: '冒险探索',
    description: '踏上未知旅程，解开谜题，发现隐藏在世界各地的秘密。',
    icon: 'ri-compass-3-line',
    gameCount: 25,
  },
  {
    slug: 'puzzle',
    name: '休闲益智',
    description: '轻松有趣的益智游戏，随时随地享受动脑的快乐。',
    icon: 'ri-lightbulb-line',
    gameCount: 40,
  },
  {
    slug: 'card-board',
    name: '棋牌桌游',
    description: '经典棋牌与创新桌游，与好友在线对战，享受博弈的乐趣。',
    icon: 'ri-vip-crown-line',
    gameCount: 22,
  },
];